import { put, call, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import client from '../client';
import { profileActions } from '../reducers/profile';
import { FullProfileState } from '../models/profile';
import { ListResponse } from '../models/common';
import { LoadProfileAction, UpdateProfileAction } from '../actionTypes/profile';

export function* loadProfile({ payload: { res, rej } }: PayloadAction<LoadProfileAction>) {
  try {
    const response: ListResponse<FullProfileState> = yield call(client, { url: 'user/profile' });
    yield put(profileActions.loadProfileSuccess(response));
    if (typeof res === 'function') {
      yield call(res);
    }
  } catch (error) {
    yield put(profileActions.loadProfileFail(error));
    if (typeof rej === 'function') {
      yield call(rej, error);
    }
  }
}

export function* updateProfile({ payload: { data, res, rej } }: PayloadAction<UpdateProfileAction>) {
  try {
    const response: ListResponse<FullProfileState> = yield call(client, {
      url: 'user/profile',
      method: 'PUT',
      data,
    });

    yield put(profileActions.updateProfileSuccess(response));
    if (typeof res === 'function') {
      yield call(res);
    }
  } catch (error) {
    yield put(profileActions.updateProfileFail(error));
    if (typeof rej === 'function') {
      yield call(rej, error);
    }
  }
}

export default function* supportSaga() {
  yield takeLatest(profileActions.loadProfile.type, loadProfile);
  yield takeLatest(profileActions.updateProfile.type, updateProfile);
}
